import { Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import CustomButton from "../../../common/CustomButton";

function BannerRestDay({ workoutPlan, selectedDate, calendar }) {
    const navigate = useNavigate();

    const mDate = moment(`${selectedDate?.year}/${selectedDate?.month}/${selectedDate?.day}`);
    const renewDate = moment(`${calendar?.dateAfterEndDate?.year}/${calendar?.dateAfterEndDate?.month}/${calendar?.dateAfterEndDate?.day}`);
    let isRenew = calendar?.dateAfterEndDate?.day == selectedDate?.day && calendar?.dateAfterEndDate?.month == selectedDate?.month && calendar?.dateAfterEndDate?.year == selectedDate?.year;
    let isRenewToday = moment().isSame(renewDate, 'day');
    const hasScheduled = workoutPlan?.schedule ? Object.keys(workoutPlan?.schedule)?.length > 0 : false;

    return (
        <>
            {workoutPlan && <div className="ydb-banner" id="ydb-banner-rest-day">
                <div className="ydb-banner-description">
                    <h4>Your Day</h4>
                    <p>{mDate?.format('dddd,')} {mDate?.format('MMMM DD')}</p>
                    {
                        (!isRenew && hasScheduled)
                            ? <>
                                <p>Rest Day!</p>
                                <p>Did you know that rest days can reduce your chance of overuse injury by up to 50%?</p>
                            </>
                            : <>
                                <p>Ready to boost your workout routine? Answer a few quick questions so we can check your progress and adjust your schedule!</p>
                                <CustomButton style={{ marginTop: "10px" }} isPrimary={true} disabled={!(!isRenewToday || !hasScheduled)} onClick={() => {
                                    navigate("/user-survey");
                                }}>Get Started</CustomButton>
                            </>
                    }
                </div>
            </div>}
            {!workoutPlan && <div className="ydb-banner" style={{ padding: 0, backgroundColor: "transparent", overflow: "hidden", height: "180px", minHeight: "180px" }}>
                <Skeleton variant="rectangular" width={"100%"} height={180} />
            </div>}
        </>
    );
}

export default BannerRestDay;